export enum WholesaleErrorType {
  NONE = "NONE",
  UNTYPED = "UNTYPED",
  DUPLICATE_LABELS = "DUPLICATE_LABELS",
}
